// src/css/servicesStyle.js

const styles = {
    container: {
      paddingTop: 11,
      '@media (min-width:600px)': {
        paddingTop: 0,
      },
      '@media (min-width:960px)': {
        paddingTop: 0,
      },
      '@media (min-width:1280px)': {
        paddingTop: 13,
      },
    },
    heading: {
      fontFamily: 'Poppins, Arial, sans-serif',
      fontSize: 36,
      fontWeight: 600,
      color: '#000000',
      textAlign: 'center',
      mt: { lg: 1, md: 1, sm: 1, xs: 9 }
    },
    subHeading: {
      fontFamily: 'Poppins, Arial, sans-serif',
      fontSize: '16px',
      fontWeight: 600,
      color: '#000000',
      textAlign: 'center',
    },
    divider: {
      width: '80%',
      // height: '1px',
      border: '2px solid black',
      marginBottom: 9,
      textAlign: 'center',
      margin: '0 auto',
      mt: "4px",
    },
    box: {
      width: '100%',
      height: '100%',
      backgroundColor: '#E9EBF7',
      textAlign: 'center',
      transition: 'all 0.3s ease', // smooth transition for hover effect
      borderRadius: '14px',
      '&:hover': {
        backgroundColor: 'white',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)', // adds a shadow on hover
      },
    },
    boxImg: {
        width: '98px',
        height: '98px',
        backgroundColor: 'red',
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        boxShadow: '0px 1px 16px 0px #00000040',
        background: '#FFFFFF',
        borderRadius: '16px',
        mt: 5,
    },
    img: {
      height: 48,
      width: 48,
    },
    title: {
      fontFamily: 'Poppins, Arial, sans-serif',
      fontSize: '16px',
      fontWeight: 600,
      color: '#000000',
      textAlign: 'center',
      paddingX: 3,
      paddingBottom: 1,
      pt: 3,
    },
    description: {
      fontFamily: 'Poppins, Arial, sans-serif',
      fontSize: '13px',
      fontWeight: 500,
      color: '#000000',
      textAlign: 'start',
      paddingX: 2,
      paddingBottom: 5,
    },
  };
  
export default styles;
  